<template>
    <div class="ending-view">
        <!-- <button @click="goToStart">klik3</button> -->
        <transition @enter="onShowOverlay">
            <overlay :tile="overlayData" @close="hideOverlay"></overlay>
        </transition>
    </div>
</template>

<style lang="scss">

</style>

<script>
    import { TimelineMax } from '@/vendor';
    import Overlay from '@/app/components/Overlay';

    export default {
        name: 'Ending',

        components: {
            'overlay': Overlay
        },

        data()
        {
            return {
                overlayData: {
                    id: 'ending',
                    title: 'Goed gedaan!',
                    header: 'Jij bent nu een #thinkcircular-kampioen!',

                    body: `Je hebt alle kaartjes onthouden en je hebt de juiste beelden bij elkaar gezocht. Dat betekent dat je nu weet hoe belangrijk het is om circulair te denken en dat je bovendien een heel goed geheugen hebt. Bedankt voor het meespelen!<br><br>#ThinkCircular`
                }
            };
        },

        computed: {
            endingCopy()
            {
                return this.$store.getters[ 'getCopy' ]( 'ending' );
            }
        },

        /*
        {
            id: 'blik',
            found: false,
            wrongAnswer: false,
            isActive: false,
            title: 'RECYCLEN',
            header: 'Afval verwerken tot herbruikbaar materiaal.',
            body: 'Wist je dat we in Nederland bijna 94% van alle blikjes recyclen? Daarin zijn wij koploper in Europa. Die blikjes worden omgesmolten en daar maken we bijvoorbeeld jouw nieuwe fiets van!'
        }
        */

        mounted()
        {
            this.overlayData.title = this.endingCopy.header;
            this.overlayData.header = this.endingCopy.subHeader;
            this.overlayData.body = this.endingCopy.body;
        },

        methods: {
            goToStart()
            {
                this.$router.push( '/' );
            },

            hideOverlay()
            {
                this.$router.push( '/' );
            },

            onShowOverlay( el, done )
            {
                // window.alert( window.innerWidth + ',' + window.innerHeight );
                let tl = new TimelineMax();
                tl.fromTo( '.overlay-view', 0.3, { y: -65, opacity: 0 }, { y: 0, opacity: 1 });
                tl.add( done );
                return tl;
            }
        }
    };
</script>
